import { Typography, Box, List, ListItem, Paper } from '@mui/material';

const ScriptDoc = () => {
    return (
        <Box sx={{ maxWidth: "800px", padding: 2 }}>
            <Typography variant="h4" gutterBottom><strong>Scripting Documentation</strong></Typography>

            <Typography variant="h5" gutterBottom>📝 Script Functions</Typography>
            <Typography variant="body1" gutterBottom>
                The following functions are available for use in scripts:
            </Typography>

            <Typography variant="h6" gutterBottom>⚡ Pre-Request Script</Typography>
            <List >
                {["hc.request.getBody()", "hc.request.getUrl()", "hc.request.setUrl(\"urlValue\")", "hc.request.getHeaders()",
                    "hc.request.getBodyType()", "hc.request.setHeader(\"key\", \"value\")", "hc.request.setJsonBody({ })",
                    "hc.request.setMethod('value')", "hc.request.getMethod()", "hc.setRequestVariable('key', 'value')",
                    "hc.getEnvVariable('key')", "hc.getGlobalVariable('key')", "hc.getVariable('key')",
                    "hc.getCollectionVariable('key')", "hc.setCollectionVariable('key', 'value')", "hc.setGlobalVariable('key', 'value')",
                    "hc.setEnvVariable('key', 'value')", "hc.getRequestVariable('key')"].map((func, index) => (
                        <ListItem key={index}>• {func}</ListItem>
                    ))}
            </List>

            <Typography variant="h6" gutterBottom>📩 Post-Response Script</Typography>
            <List >
                {["hc.response.getBody()", "hc.response.getStatus()", "hc.response.getStatusText()", "hc.response.getHeaders()",
                    "hc.response.getTimeTaken()", "hc.test(\"description\", () => { })", "hc.getEnvVariable('key')",
                    "hc.getGlobalVariable('key')", "hc.getVariable('key')", "hc.getCollectionVariable('key')",
                    "hc.setCollectionVariable('key', 'value')", "hc.setGlobalVariable('key', 'value')", "hc.setEnvVariable('key', 'value')"].map((func, index) => (
                        <ListItem key={index}>• {func}</ListItem>
                    ))}
            </List>
            <br />
            <br />
            <Typography variant="h6" gutterBottom>🛠️ Example: Writing Tests</Typography>
            <Paper elevation={3} sx={{ padding: 2, backgroundColor: "#f5f5f5", borderRadius: 1, overflowX: "auto" }}>
                <pre style={{ margin: 0 }}>
                    {`hc.test("should match expected value", () => {
    const body = hc.response.getBody();
    expect(body.value[0].name).to.equal("ram");
});`}
                </pre>
            </Paper>
        </Box>
    )
};

export default ScriptDoc;
